module.exports = __webpack_public_path__ + "img/accept-reject-i-icon.b70d0993.svg";